import axios from "axios";

import authHeader from "./auth-header";
import AdminService from "./admin.service";
import UserService from "./user.service";
import ErrorService from "./error.service";

const API_AI_SERVICE_ADMIN_URL = AdminService.getBaseUrl() + "/api/v1/ai-service";

class AIService {
    async getAllAITypes(callback) {
        await axios
            .get(API_AI_SERVICE_ADMIN_URL + "/get-all-ai-types", { headers: await authHeader() })
            .then(response => {
                callback(response.data);
            })
            .catch(error => {
                throw error;
            });
    }
  
    async saveAIToolsetToClient(clientCode, aiTypeId, applyToHierarchy, callback, app) {
        const params = new URLSearchParams();
        params.append("clientCode", clientCode);
        params.append("aiTypeId", aiTypeId);
        params.append("applyToHierarchy", applyToHierarchy);
        //params.append("clientSettingTypeName", "ai-type-id");
        params.append("userId", UserService.getUserId());
        await axios
          .post(API_AI_SERVICE_ADMIN_URL + "/save-ai-type-to-client", params, { headers: await authHeader() })
          .then(response => callback(response))
          .catch(error => {
            error.message += ErrorService.mergeError(error.response);
            ErrorService.processError("AIService.saveAIToolsetToClient", error, "admin", app);
          });
    }
}
export default new AIService();
